import { HOME } from "@/constants/testIds";
import { IMAGES } from "@/constants/neco";

export const Hero = () => (
  <section id="top" data-testid={HOME.heroSection} className="relative min-h-screen flex items-center overflow-hidden">
    <div className="absolute inset-0">
      <img
        src={IMAGES.hero}
        alt="Neco Plaza — avizeler ve çiçeklerle süslü balo salonu"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/50" />
      <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-[#121110] to-transparent" />
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full pt-32 pb-24">
      <p className="fade-up fade-up-1 text-xs uppercase tracking-[0.4em] text-[#D4AF37] mb-7">
        1973'ten beri · Samsun
      </p>
      <h1
        data-testid={HOME.heroTitle}
        className="fade-up fade-up-2 font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-[#F5F5F0] max-w-4xl leading-[1.05]"
      >
        Hayalinizdeki Düğün
        <br />
        <span className="font-romance text-[#E5C783] font-medium">Gerçeğe Dönüşüyor</span>
      </h1>
      <p className="fade-up fade-up-3 mt-8 max-w-2xl text-base md:text-lg font-light leading-relaxed text-[#B3B0A8]">
        Neco Plaza Sultan salonlarında, ömür boyu sürecek birlikteliğinizin başlangıcı olacak
        rüyaların düğününe ev sahipliği yapıyoruz. Siz günün tadını çıkarın.
      </p>
      <div className="fade-up fade-up-4 mt-12 flex flex-wrap gap-4">
        <a
          href="#rezervasyon"
          data-testid={HOME.heroReservationButton}
          className="bg-[#D4AF37] hover:bg-[#E5C783] text-[#121110] px-10 py-4 text-xs uppercase tracking-[0.25em] font-semibold transition-colors duration-300"
        >
          Online Rezervasyon
        </a>
        <a
          href="#salonlar"
          data-testid={HOME.heroHallsButton}
          className="border border-[#F5F5F0]/40 hover:border-[#D4AF37] text-[#F5F5F0] hover:text-[#E5C783] px-10 py-4 text-xs uppercase tracking-[0.25em] transition-colors duration-300"
        >
          Salonları Keşfet
        </a>
      </div>

      <div className="fade-up fade-up-4 mt-16 flex flex-wrap gap-x-10 gap-y-3 text-xs uppercase tracking-[0.2em] text-[#B3B0A8]">
        <span><span className="text-[#D4AF37]">●</span> 4 Ayrı Sultan Salonu</span>
        <span><span className="text-[#D4AF37]">●</span> 300 – 2000 Kişi Kapasite</span>
        <span><span className="text-[#D4AF37]">●</span> Deniz Manzaralı Teras</span>
      </div>
    </div>
  </section>
);
